import React, { useEffect, useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';
import LoaderStore from 'lib/stores/loaderStore';
import SubmitButton from 'lib/components/SubmitButton';
import clsx from 'clsx';

const Modal = ({ title, content, onAccept, onClose, acceptMessage, open, id, disabled, flexible, formId, children }) => {
  const modalRef = useRef();
  const { status } = LoaderStore.useState(state => state);
  const wrapperClasses = clsx(
    'modal',
    'modal-wrapper',
    'fade',
  );
  const dialogClasses = clsx(
    'modal-dialog modal-dialog-centered modal-lg',
    !flexible && 'contract-modal',
  );

  const handleSubmit = async () => {
    if (!onAccept) return;

    await onAccept();
  };

  useEffect(() => {
    const onModalClose = () => { onClose(); };

    if (!onClose) return;
    if (!modalRef || !modalRef.current) return;

    modalRef.current.addEventListener('hidden.bs.modal', onModalClose);

    return () => {
      modalRef.current.removeEventListener('hidden.bs.modal', onModalClose);
    };
  }, []);

  return (
    <div
      className={wrapperClasses}
      role="dialog"
      tabIndex="-1"
      id={id}
      aria-hidden="true"
      ref={modalRef}
      data-testid="modal"
    >
      <div className={dialogClasses}>
        <div className="modal-content position-relative overflow-auto p-4">
          {title && (
            <div className="modal-header">
              <h2 className="h6 modal-title">{title}</h2>
              {onClose && (
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  disabled={status === 'pending'}
                  onClick={onClose}
                />
              )}
            </div>
          )}
          {open && (
            children ? (
              <div className="modal-body">
                {children}
              </div>
            ) : (
              <div className="modal-body">
                {ReactHtmlParser(content)}
              </div>
            )
          )}
          {(onAccept || formId) && (
            <div className="modal-footer">
              <SubmitButton
                formId={formId}
                className="btn-secondary ms-auto"
                onClick={handleSubmit}
                testid="modalAccept"
                disabled={disabled}
                label={acceptMessage || 'Accept'}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
